import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import GrayscalePDFImageListScreen from "./GrayscalePDFImageListScreen";
import { BASE_URL } from "../Config";

function GrayscalePDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Convert PDF to Grayscale" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/grayscale_pdf", title: "Grayscale PDF file" },
    data2: { link: "/grayscale_pdf", title: "PDF Converter to Grayscale" },
    data3: { link: "/grayscale_pdf", title: "Convert PDF to Black & White" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert PDF to grayscale online. Reduce file size, save ink, and create black and white PDFs quickly with our fast and easy grayscale PDF tool."
      ></meta>
      <meta
        name="keywords"
        content="grayscale PDF, convert PDF to grayscale, PDF to black and white, PDF color to grayscale, PDF editor online, black-and-white PDF, PDF optimization tool, reduce PDF size, PDF file converter, online PDF tool, PDF management tool, grayscale PDF converter, PDF color converter, PDF editing tool, compress PDF"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <GrayscalePDFImageListScreen
          title={title}
        ></GrayscalePDFImageListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Grayscale PDF Converter website provides a fast, secure, and efficient solution to convert color PDF files into grayscale both offline and online. Built for users who prioritize privacy and performance, this powerful tool allows you to convert PDFs to grayscale directly on your device without requiring an active internet connection. By processing files locally, the converter ensures complete data security while delivering high-quality grayscale output with clear text and optimized images. Whether you need to reduce ink usage for printing, create lightweight documents, or standardize PDFs for official submissions, this grayscale PDF converter delivers reliable results every time. In addition to offline functionality, the platform also supports grayscale PDF converter online features for users who prefer browser-based access. Using advanced conversion technology, the tool intelligently converts PDFs to grayscale while preserving layout, formatting, and readability. Ideal for students, professionals, and businesses, this grayscale PDF converter helps reduce file size, improve printing efficiency, and maintain document consistency. Compatible with desktop and mobile devices, the website offers a smooth, user-friendly experience without complex settings or software installation. If you are looking for the best grayscale PDF converter offline, grayscale PDF converter online, convert PDF to black and white, or a secure PDF color-to-grayscale tool, this platform is designed to meet all your document conversion needs with speed, accuracy, and privacy." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Convert",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Grayscale PDF"
            why_use={[
              {
                title: "Reduce Printing Costs and Ink Usage",
                description:
                  "Color printing consumes more ink and increases costs. A grayscale PDF converter helps convert color PDFs to black and white, saving ink and making printing more economical.",
              },
              {
                title: "Optimize PDFs for Official Submissions",
                description:
                  "Many government forms, academic institutions, and corporate portals require documents in grayscale or black and white. Using a convert PDF to grayscale tool ensures compliance with submission guidelines.",
              },
              {
                title: "Reduce PDF File Size",
                description:
                  "Color images increase PDF file size. When you use a grayscale PDF converter online, it helps reduce PDF size while maintaining text clarity and document quality.",
              },

              {
                title: "Improve Document Readability",
                description:
                  "Grayscale PDFs remove unnecessary colors and distractions, making text and graphics easier to read. A PDF to grayscale converter improves visual consistency across pages.",
              },
              {
                title: "Enhance Printing Speed and Quality",
                description:
                  "Black-and-white documents print faster and more consistently than color files. A grayscale PDF converter ensures clean and sharp print results on all printers.",
              },
              {
                title: "Ensure Better Compatibility Across Devices",
                description:
                  "Some devices and e-readers display grayscale documents more clearly. Using a grayscale PDF converter online improves document compatibility on mobile, tablet, and desktop devices.",
              },
              {
                title: "Protect File Privacy with Offline Conversion",
                description:
                  "Our offline grayscale PDF converter processes files directly on your device, ensuring data privacy and security without uploading documents to the internet.",
              },
              {
                title: "Ideal for Students and Professionals",
                description:
                  "Students submitting assignments and professionals preparing reports often need grayscale documents. A reliable PDF grayscale converter provides a quick and efficient solution.",
              },
              {
                title: "Standardize Document Appearance",
                description:
                  "Grayscale conversion ensures a uniform look for multi-page documents with mixed colors. A convert PDF to black and white tool maintains consistency and professionalism.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1609168763}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default GrayscalePDFMain;
